const resources = {
  zh: {
    translation: {
      "Please select": "請選擇",
      "Not a Member": "非會員",
      "Fill in the information": "填寫資料",
      Prefix: "* 稱謂",
      Mr: "Mr 先生",
      Mrs: "Mrs 太太",
      Ms: "Ms 女士",
      Miss: "Miss小姐 ",
      Dr: "Dr 博士",
      Professor: "Professor 教授",
      Others: "Others 其他",
      "Chinese lastname": "中文姓氏",
      "Chinese firstname": "中文名字",
      "English lastname": "* 英文姓氏",
      "English firstname": "* 英文名字",
      "Parent/Guardian's English Lastname": "* 家長/監護人姓氏",
      "Parent/Guardian's English Firstname": "* 家長/監護人名字",
      "Emergency Contact's English Lastname": "* 緊急聯絡人姓氏",
      "Emergency Contact's English Firstname": "* 緊急聯絡人名字",
      "Emergency Contact's Phone no.": "* 緊急聯絡人電話號碼",

      Gender: "性別",

      Male: "Male 男",
      Female: "Female 女",
      Other: "Other 其他",

      "Confirm email": "*確認電郵",
      "Phone type": "* 聯絡電話類型",
      Local: "本地",
      International: "海外",
      "Phone No.": "*電話號碼",
      "Select payment method": "選擇付款方法",
      Required: "必需填寫",
      "Invalid email": "請輸入正確的電郵地址",
      "Email Confrimation does not match email": "確認電郵與電郵不相符",
      "Invalid Phone no.": "請輸入正確的手提電話號碼",
      "Year of Birth": "出生年份",
      "Invalid Year of Birth": "請輸入正確的出生年份",
      "Month of Birth": "出生月份",
      "Receipt Name": "免稅收據抬頭名稱",
      "Receipt Address": "收據郵寄地址",
      "Receipt HelperText":
        "收據會發送到您的電子郵箱， 如需紙本收據，請填寫地址。",
      Job: "職業",
      LivingArea: "居住地區",
      Attachment: "補充資料",
      Browse: "瀏覽",
      "Upload a file": "上傳檔案",
      "Personal Information Collection Statement": "《收集個人資料聲明》",
      Clear: "重新輸入",
      Submit: "提交",
      Donation: "善心捐款",
      "Event Enrollment": "活動報名",
      "Transaction Result": "交易結果",
      "Transaction Failed": "交易過時",
      "I am Member": "我是會員",
      Trial: "試課",
      "Become Member": "非會員",
      "Fill in the Child information": "填寫學員信息",
      "Fill in the Parent information": "填寫家長/監護人信息",
      Back: "返回",
      "Donation Amount": "單次捐款金額",
      "Other Amount": "其他金額",
      "Custom Amount": "自訂金額",
      "Not less than 50": "網上捐款最低限額為港幣50元",
      "Need receipt": "是否需要捐款收據（捐款港幣$100以上才予收據）",
      Yes: "是",
      No: "否",
      "Please scan": "請掃瞄 QR Code 進行付款",
      Confirmation: "確認資料",
      "FPS Payment": "FPS 付款",
      "Card Payment": "信用卡支付",
      "Event Page diabled": "有關Elite Paradise的資訊，請前往網頁：",
      "Event Page diabled Email": "如有任何查詢，歡迎電郵至",
      disabled_full:
        "此活動已額滿，謝謝支持！相關資訊請留意本機構的網站或電郵至",
      disabled_expired:
        "此活動已截止報名，謝謝支持！相關資訊請留意本機構的網站或電郵至",
      disabled_stop:
        "此活動已截止報名，謝謝支持！相關資訊請留意本機構的網站或電郵至",
      disabled_cancel: "此活動已取消。相關資訊請留意本機構的網站或電郵至",
      disabled_pause: "此活動已暫停報名。相關資訊請留意本機構的網站或電郵至",
      "learn more": "了解更多。",
      "Please wait FPS": "請稍後片刻，系統將跳轉到FPS付款頁面",
      "Please wait PayMe": "請稍後片刻，系統將跳轉到PayMe付款頁面",
      "Please scan - Event":
        "*請在10分鐘內完成交易，否則系統將不會保留該名額，用戶需要重新進行登記。",
      "Please scan - Donation": "*請在10分鐘內完成交易。",
      "QR code title": "請使用銀行手機應用程式掃瞄以下二維碼",
      "PayCode title": "請用 PayMe 掃描此 PayCode",
      "Card title": "請填寫您的信用卡信息",
      "Donation Success Result": "交易結果",
      "Donation Fail Result": "操作過時",
      "Donation Transaction Fail Result": "付款失敗",
      "Event Success Result": "報名結果",
      "Event Fail Result": "操作過時",
      "Event Transaction Fail Result": "付款失敗",
      "Don't close": "交易完成前請不要關閉此頁面",
      "QR payment 1": "打開支援「轉數快」的銀行手機應用程式或支付應用程式。",
      "QR payment 2": "掃描二維碼，查閱交易詳情並確認付款指引。",
      "QR payment 2 info":
        "如你是使用流動裝置，你只需要將此頁的二維碼截圖並上載至應用程式以完成結帳。",
      "QR payment 3": "在應用程式完成付款後，請留在此頁面等待確認。",
      "QR payment 3 info": "有關應用程式的詳細資訊，請與該支付服務供應商聯繫。",
      "QR payment 0 PayMe": "如何用 PayMe 付款？",
      "QR payment 1 PayMe": "打開 PayMe 應用程式",
      "QR payment 2 PayMe": "掃描 PayCode 以授權付款",
      "QR payment 3 PayMe": "在 PayMe 完成交易後，請留在此頁面等待確認",
      "information provided":
        "閣下向卓嶺 (「本公司」）提供的資料，包括個人資料（私隱）條例所指的個人資料，只會用作處理課程申請（包括通訊及意見收集）及分析或統計數據。 除經本公司授權者外，本公司不會將您的個人資料轉讓給任何第三方。 您必須向本公司提供完整的信息。 未能提供完整信息可能導致本公司無法處理和/或考慮您的申請。",
      "personal information":
        "您提供的個人信息（包括姓名、聯繫方式等）將作為與本公司的溝通渠道，將與您分享本公司的簡報、課程、活動的宣傳信息。 如果您同意接收此類信息，請在下方方框內添加“✔”接收信息欄。",
      "aggree information": "我同意接收來自 Elite Paradise 的促銷信息",
      "dont want to receive":
        "如果您以後不想再收到本公司的宣傳信息，可以發郵件至",
      photoshoot:
        "本公司將在活動期間安排拍攝和錄像，日後可能會使用相關照片和視頻作為教學和宣傳用途。",
      "agree photoshoot":
        "我同意 Elite Paradise 在活動期間安排拍攝和錄像，並可以將相關照片和視頻用於教學和宣傳用途。",
      "change information": "如果您想查看或更改您的個人信息，請發送電子郵件至",
      "Kids First Name": "*學員姓名",
      "Kids Other Name": "其他名字",
      Confirmation: "資料確認",
      "Class Enrolment": "報名班級",
      "Class Name": "班級名稱",
      "Total Amount": "報名金額",
      Status: "類別",
      Title: "稱謂",
      "Parent's Name": "*父母姓名",
      Gender: "性別",
      Email: "電子郵件",
      Phone: "*電話",
      "Date of Birth": "*出生日期",
      "Emergency Contact Name": "緊急聯繫人姓名",
      "Emergency Contact Phone Number": "*緊急聯繫電話號碼",
      "Receive Promotional Information": "個人資料收集聲明",
      "Agree to Shoot Video": "同意拍攝視頻",
      "Payment Methods": "付款方式",

      "Additional materials": "補充資料",
      "success Pay at Site":
        "您已成功預訂該課程的名額。 您的名額將保留 48 小時。 請到櫃檯確認最終登記。我們很高興您的孩子參加我們極具創意和發掘潛能課程, 盼望你的到來, 謝謝!",

      "old class":
        "抱歉，此操作已過時並關閉，系統將不會保留該名額，請重新登記。如果對是項操作有任何問題，請與",
      "success enroll": "您已成功註冊此課程。",
      "fee note":
        "*Please note that a registration fee of HKD300 for membership will be added on top of the class enrollment fee.",
      "confirmation modal": "請截圖付款畫面及交易號碼以供記錄",
      "*Please Enter English Characters": "*祇允許英文字元",
      "For demo purpose: please enter 411 111 111 111 as the card number and any valid date to complete the payment process.": "示範用途：請輸入 411 111 111 111 作為卡號和任何有效日期以完成付款流程。",
      "agree information" : "我同意接收來自 Elite Paradise 的促銷信息"
    },
  },
  en: {
    translation: {
      "Please select": "Please select",
      "Fill in the information": "Fill in the information",
      Prefix: "* Prefix",
      Mr: "Mr 先生",
      Mrs: "Mrs 太太",
      Ms: "Ms 女士",
      Miss: "Miss小姐 ",
      Dr: "Dr 博士",
      Professor: "Professor 教授",
      "I am Member": "I am Member",
      "Become Member": "Non Member",
      Trial: "Trial",
      "Fill in the Child information": "Child information",
      "Fill in the Parent information": "Parent/Guidance information",
      Others: "Others 其他",
      "Chinese lastname": "Chinese lastname",
      "Chinese firstname": "Chinese firstname",
      "English lastname": "* English lastname",
      "English firstname": "* English firstname",
      "Parent/Guardian's English Lastname":
        "Parent/Guardian's English Lastname",
      "Parent/Guardian's English Firstname":
        "Parent/Guardian's English Firstname",
      "Emergency Contact's English Lastname":
        "Emergency Contact's English Lastname",
      "Emergency Contact's English Firstname":
        "Emergency Contact's English Firstname",
      "Emergency Contact's Phone no.": "Emergency Contact's Phone no.",
      Gender: "Gender",
      Male: "Male 男",
      Female: "Female 女",
      Other: "Other 其他",
      Email: "* Email",
      "Confirm email": "*Confirm email",
      "Phone type": "* Phone type",
      Local: "Local",
      International: "International",
      "Phone No.": "* Phone No.",
      "Select payment method": "Select payment method",
      Required: "Required",
      "Invalid email": "Invalid email",
      "Email Confrimation does not match email":
        "Email Confrimation does not match email",
      "Invalid Phone no.": "Invalid Phone no.",
      "Year of Birth": "Year of Birth",
      "Invalid Year of Birth": "Invalid Year of Birth",
      "Month of Birth": "Month of Birth",
      "Receipt Name": "Receipt Name",
      "Receipt Address": "Receipt Address",
      "Receipt HelperText": "Receipt HelperText",
      Job: "Job",
      LivingArea: "LivingArea",
      Attachment: "Attachment",
      Browse: "Browse",
      "Upload a file": "Upload a file",
      "Personal Information Collection Statement":
        "Personal Information Collection Statement",
      Clear: "Clear",
      Submit: "Submit",
      Donation: "Donation",
      "Event Enrollment": "Event Enrollment",
      "Transaction Result": "Transaction Result",
      "Transaction Failed": "Transaction Failed",
      Back: "Back",
      "Donation Amount": "Donation Amount",
      "Other Amount": "Other Amount",
      "Custom Amount": "Custom Amount",
      "Not less than 50": "Not less than 50",
      "Need receipt": "Need receipt",
      Yes: "Yes",
      No: "No",
      "Please scan": "Please scan",
      Confirmation: "Confirmation",
      "FPS Payment": "FPS Payment",
      "Card Payment": "Card Payment",
      "Event Page diabled":
        "For information on Elite Paradise, please visit the website: ",

      "Event Page diabled Email": "For any inquiries, please email: ",
      disabled_full:
        "此活動已額滿，謝謝支持！相關資訊請留意本機構的網站或電郵至",
      disabled_expired:
        "此活動已截止報名，謝謝支持！相關資訊請留意本機構的網站或電郵至",
      disabled_stop:
        "此活動已截止報名，謝謝支持！相關資訊請留意本機構的網站或電郵至",
      disabled_cancel: "此活動已取消。相關資訊請留意本機構的網站或電郵至",
      disabled_pause: "此活動已暫停報名。相關資訊請留意本機構的網站或電郵至",
      "learn more": "了解更多。",
      "Please wait FPS": "請稍後片刻，系統將跳轉到FPS付款頁面",
      "Please wait PayMe": "請稍後片刻，系統將跳轉到PayMe付款頁面",
      "Please scan - Event":
        "*請在10分鐘內完成交易，否則系統將不會保留該名額，用戶需要重新進行登記。",
      "Please scan - Donation": "*請在10分鐘內完成交易。",
      "QR code title": "請使用銀行手機應用程式掃瞄以下二維碼",
      "PayCode title": "請用 PayMe 掃描此 PayCode",
      "Card title": "Please fill in your credit card information",
      "Donation Success Result": "交易結果",
      "Donation Fail Result": "Obsolete operation",
      "Donation Transaction Fail Result": "付款失敗",
      "old class":
        "Sorry, this operation is outdated and closed, the system will not reserve this quota, please register again. If you have any questions about this operation, please contact ",
      "Event Success Result": "Enrolment Success",
      "Event Fail Result": "Obsolete operation",
      "Event Transaction Fail Result": "付款失敗",
      "Don't close": "交易完成前請不要關閉此頁面",
      "QR payment 1": "打開支援「轉數快」的銀行手機應用程式或支付應用程式。",
      "QR payment 2": "掃描二維碼，查閱交易詳情並確認付款指引。",
      "QR payment 2 info":
        "如你是使用流動裝置，你只需要將此頁的二維碼截圖並上載至應用程式以完成結帳。",
      "QR payment 3": "在應用程式完成付款後，請留在此頁面等待確認。",
      "QR payment 3 info": "有關應用程式的詳細資訊，請與該支付服務供應商聯繫。",
      "QR payment 0 PayMe": "如何用 PayMe 付款？",
      "QR payment 1 PayMe": "打開 PayMe 應用程式",
      "QR payment 2 PayMe": "掃描 PayCode 以授權付款",
      "QR payment 3 PayMe": "在 PayMe 完成交易後，請留在此頁面等待確認",
      "information provided":
        "The information provided by you to Elite Paradise ('the Company'), including the personal data referred to in the Personal Data (Privacy) Ordinance, will only be used for processing the registration application(including communications and opinion gathering), and analytics or statistics. Except for those authorized by the Company, the Company will not transfer your personal data to any third party. You must provide complete information to the Company. Failure to provide complete information may result in our Company being unable to process and/or consider your application.",
      "personal information":
        "The personal information you provide (including name, contact information, etc.) will be used as a communication channel with the Company, and will share with you the promotional information of the Company's newsletters, courses or events activities. If you agree to receive such information, please add '✔' in the box below to receive the information column.",
      "aggree information":
        "I agree to receive promotional information from Elite Paradise",
      "dont want to receive":
        "If you do not want to receive promotional information from this organization in the future, you can email to",
      photoshoot:
        "Our Company will arrange for shooting and video recording during the event, and may use relevant photos and videos for teaching and publicity purposes in the future.",
      "agree photoshoot":
        "I agree that Elite Paradise arranges shooting and video recording during the event, and can use the relevant photos and videos for teaching and publicity purposes.",
      "change information":
        "If you wish to view or change your personal information, please email to ",
      "Kids First Name": "*Kids First Name",
      "Kids Other Name": "Kids Other Name",
      Confirmation: "Confirmation",
      "Class Enrolment": "Class Enrolment",
      "Class Name": "Class Name",
      "Total Amount": "Total Amount",
      Status: "Status",
      Title: "Title",
      "Parent's Name": "*Parent/Guidance's Name",
      Gender: "*Gender",
      Email: "*Email",
      Phone: "*Phone",
      "Date of Birth": "*Date of Birth",
      "Emergency Contact Name": "*Emergency Contact Name",
      "Emergency Contact Phone Number": "*Emergency Contact Phone Number",
      "Receive Promotional Information":
        "Personal Information Collection Declaration",
      "Agree to Shoot Video": "Agree to Shoot Video",
      "Payment Methods": "Payment Methods",
      "Additional materials": "Additional materials",
      "success Pay at Site":
        "You have successufuly reserve a seat in the this class. Your seat will reserve for 48-hour. Please come to counter to confirm the final registration. ",
      "success enroll": "You have successfully registered for this course.",
      "Not a Member": "Non Member",
      "fail Pay at Site":
        "Apologies, there was an issue while attempting to enroll for this class. Please try again.",
      "Something wrong": "Something went wrong",
      "fee note":
        "*Please note that a registration fee of HKD300 for membership will be added on top of the class enrollment fee.",
      "confirmation modal":
        "Please screen shot the payment screen with transaction number for record purpose or download the payment receipt",
      "*Please Enter English Characters": "*Please Enter English Characters",
      "For demo purpose: please enter 411 111 111 111 as the card number and any valid date to complete the payment process.":"For demo purpose: please enter 411 111 111 111 as the card number and any valid date to complete the payment process.",
      "agree information" : "I agree to receive promotional information from Elite Paradise"
    },
  },
};

export default resources;
